import http from './http'

export async function getNotice(id, size = 10) {
    return await http.get("/notice", { params: { "notice-id": id === null ? null : id, "size": size } }).then(response => {
        if (response.status === 200) {
            return response
        }
    }).catch(() => console.error("공지 정보를 얻는데 실패했습니다."))
}

export async function getNoticeDetail(id) {
    return await http.get("/notice/detail", { params: { "notice-id": id } }).then(response => {
        if (response.status === 200) {
            return response
        }
    }).catch(() => console.error("공지 정보를 얻는데 실패했습니다."))
}

export async function postNotice(request) {
    return await http.post("/admin/notice", JSON.stringify(request)).then(response => {

        if (response.status === 201) {
            return response
        }
    }).catch(() => console.error("공지 생성에 실패했습니다."))

}

export async function editNotice(request) {
    return await http.put("/admin/notice", JSON.stringify(request)).then(response => {

        if (response.status === 200) {
            return response
        }
    }).catch(() => console.error("공지 수정에 실패했습니다."))
}

export async function deleteNotice(id) {
    return await http.delete("/admin/notice", { params: { "notice-id": id } }).then(response => {
        if (response.status === 200 || response.status === 204) {
            return response
        }
    }).catch(() => console.error("공지 삭제에 실패했습니다."))
}